import React from 'react';
import { Card, CardBody, CardHeader } from '@edgebox/react-components';

export function RawDataCard({ entity }: { entity: unknown }) {
  return (
    <Card className="mb-3">
      <CardHeader>Raw data</CardHeader>
      <CardBody>
        <pre className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(entity, null, 2)}
        </pre>
      </CardBody>
    </Card>
  );
}
